<template>
  <transition name="fade">
    <div id="coins-agree" class="coins-agree" v-if="visible">
      <div class="coins-agree-shadow" @click="hideCoinsAgreePopup"></div>
      <div class="coins-agree-main">
        <a
          href="javascript:;"
          class="main-close"
          @click="hideCoinsAgreePopup"
        ></a>
        <div class="main-content">
          <h2 class="main-content-title">
            {{ letter.abountZbit.replace('\${Z-BIT}', getCoinsName) }}
          </h2>
          <div class="main-content-desc scroll">
            <p class="agree-text">{{ coinsIntro }}</p>
            <a :href="serviceLink" class="agree-link" target="_blank">{{
              letter.fwtk
            }}</a>
          </div>
          <a href="javascript:;" class="agree-confirm" @click="confirm">{{
            letter.mywork_confirm
          }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import serviceLink from '@mixins/officialStore/serviceLink';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';

export default {
  name: 'CoinsAgreePopup',
  mixins: [serviceLink],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    ...mapGetters(['getCoinsName']),
    coinsIntro() {
      const coinsIntroLang = gameInfoConfig[+this.gameId].coinsIntro;
      if (!coinsIntroLang) {
        return '';
      }
      return coinsIntroLang[this.lang] ? coinsIntroLang[this.lang] : '';
    }
  },
  data() {
    return {
      boolAgree: false
    };
  },
  methods: {
    hideCoinsAgreePopup() {
      this.$emit('update:visible', false);
    },
    confirm() {
      this.hideCoinsAgreePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.coins-agree {
  z-index: 20;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('coins-agree-popup-bg.png');
  }

  .main {
    &-close {
      position: absolute;
      right: 46px;
      top: 36px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
    &-content {
      &-title {
        margin: 62px auto 22px;
        font-size: 48px;
        font-weight: bold;
        text-align: center;
        color: #64563c;
      }
      &-desc {
        overflow: auto;
        height: 472px;
        margin: 22px 48px 48px;
        padding-right: 12px;
        font-size: 24px;
        font-weight: normal;
        line-height: 36px;
        text-align: left;
        color: #64563c;

        .agree-text {
          margin-bottom: 22px;
        }
        .agree-link {
          display: inline-block;
          padding-bottom: 3px;
          margin-left: 56px;
          border-bottom: 1px solid #64563c;
          font-size: 24px;
          color: #64563c;
        }
        .agree-item {
          color: #64563c;
        }
      }
      .agree-confirm {
        display: block;
        margin: auto;
        font-size: 24px;
        line-height: 65px;
        text-align: center;
        color: #fffada;
        @psetbg ('coins-agree-confirm.png');
      }
    }
  }
}
</style>
